export const insertNewUser = () => {
  return process.env.REACT_APP_USER_SERVER + "/member/new";
};

const post_api = {
  insertNewUser,
};

export default post_api;
